module.exports = __webpack_public_path__ + "img/footer-map.1d2a766.png";